import React from 'react';
import { Phone, Mail, Globe } from 'lucide-react';

/**
 * Public footer for the ProcureOne Ultra homepage (Feb 2026 — Founder brief).
 *
 * Utilitarian single-strip footer aligned with the GeM-style IA restructure:
 * one row on desktop (phone · email · website on the left, copyright on the
 * right), stacked on mobile. Dark navy `#0A1F44` matches the header /
 * sidebar palette. Uses the same brand constants surfaced elsewhere on the
 * landing page so contact details stay single-sourced.
 */
const SUPPORT_PHONE_DISPLAY = '+91 83692 11947';
const SUPPORT_PHONE_E164    = '+918369211947';
const SUPPORT_EMAIL         = 'info@plusultrainnovation.com';
const SITE_URL              = 'https://plusultrainnovation.com';
const SITE_DISPLAY          = 'plusultrainnovation.com';

export default function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      id="contact"
      className="bg-[#0A1F44] text-slate-200 border-t border-white/10"
      data-testid="public-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-sm">
        <ul className="flex flex-col sm:flex-row flex-wrap gap-x-6 gap-y-2">
          <li className="flex items-center gap-2">
            <Phone className="w-4 h-4 text-[#D4AF37] shrink-0" />
            <a
              href={`tel:${SUPPORT_PHONE_E164}`}
              className="hover:text-[#D4AF37] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] rounded-sm"
              data-testid="footer-phone"
            >
              {SUPPORT_PHONE_DISPLAY}
            </a>
          </li>
          <li className="flex items-center gap-2">
            <Mail className="w-4 h-4 text-[#D4AF37] shrink-0" />
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="hover:text-[#D4AF37] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] rounded-sm break-all"
              data-testid="footer-email"
            >
              {SUPPORT_EMAIL}
            </a>
          </li>
          <li className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-[#D4AF37] shrink-0" />
            <a
              href={SITE_URL}
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#D4AF37] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] rounded-sm"
              data-testid="footer-website"
            >
              {SITE_DISPLAY}
            </a>
          </li>
        </ul>
        <div
          className="text-[11px] sm:text-xs text-slate-400 text-left md:text-right"
          data-testid="footer-copyright"
        >
          © {year} Plus Ultra Innovation. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
